export const matchName = (match, name) => {
  switch (match.type) {
    case 'string':
      return match.name === name

    case 'map':
      return !!match.names[name]

    case 'regexp':
      return match.regexp.test(name)
  }

  return false
}
